import { createContext, useContext, useEffect, useState } from 'react';
import { getTenantFromHostname } from '../utils/getTenantFromHostname';

const TenantContext = createContext();

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    const tenantId = getTenantFromHostname();
    setTenant(tenantId);
    
  }, []);

  return (
    <TenantContext.Provider value={{ tenant }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);